import { apiSlice } from "app/api/apiSlice"

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        askAi: builder.mutation({
            query: aiPrompt => ({
                url: '/ai/ask',
                method: 'POST',
                body: aiPrompt
            })
        }),
        getAiStatus: builder.query({
            query: ()=> "/ai/status",
            keepUnusedDataFor: 5,
        }),
    }),

})

export const {
    useAskAiMutation,
    useGetAiStatusQuery
} = authApiSlice